import Joi from 'joi';
import {
  ASSURANCE_DATA_TYPE_CARD,
  ASSURANCE_DATA_TYPE_CARDHOLDER,
  ASSURANCE_DATA_TYPE_CONSUMER,
  ASSURANCE_DATA_TYPE_DEVICE,
  ASSURANCE_DATA_TYPE_RELATIONSHIP
} from '../../constants/assurance-data-enums';

const AssuranceData = Joi.object()
  .keys({
    verificationData: Joi.array()
      .items(
        Joi.object()
          .keys({
            verificationEntity: Joi.string()
              .length(2)
              .required(),
            verificationMethod: Joi.string()
              .length(2)
              .required(),
            verificationResults: Joi.string()
              .length(2)
              .required(),
            verificationTimestamp: Joi.date()
              .timestamp('unix')
              .required(),
            verificationType: Joi.string()
              .valid(
                ASSURANCE_DATA_TYPE_CARD,
                ASSURANCE_DATA_TYPE_CARDHOLDER,
                ASSURANCE_DATA_TYPE_CONSUMER,
                ASSURANCE_DATA_TYPE_DEVICE,
                ASSURANCE_DATA_TYPE_RELATIONSHIP
              )
              .optional()
          })
          .optional()
      )
      .optional()
  })
  .optional();

export default AssuranceData;
